module.exports = __webpack_public_path__ + "img/training_course_5.18e3a776.jpg";